const $ = window.jQuery;
const $window = window.$window || $(window);

const ChartToggle = {

    init () {
        var $module = $('.chart-toggle');
        if (!$module.length)
            return;
        $('.ami-toggle button').each(function(i,e){
          $(this).on('click', function(){
            $('.ami-toggle button').removeClass('active');
            $(this).addClass('active');
            if(i == 0){
              $('.chart-toggle-nav button').removeClass('hide');
              $('.chart-toggle-nav button:nth-child(4), .chart-toggle-nav button:nth-child(5), .chart-toggle-nav button:nth-child(6)').addClass('hide');
              $('.chart-toggle-nav button').removeClass('active');

                $('.chart-toggle-nav button').removeClass('active');
                $('.chart-toggle-nav button:eq(0)').addClass('active');
                $('.chart-toggle .items .item').hide();
                $('.chart-toggle .items .item:eq(0)').show();
                $('.chart-toggle-copy .items .item').hide();
                $('.chart-toggle-copy .items .item:eq(0)').show();
            }
            if(i == 1){
              $('.chart-toggle-nav button').removeClass('hide');
              $('.chart-toggle-nav button:nth-child(1), .chart-toggle-nav button:nth-child(2), .chart-toggle-nav button:nth-child(3)').addClass('hide');
                
                $('.chart-toggle-nav button').removeClass('active');
                $('.chart-toggle-nav button:eq(3)').addClass('active');
                $('.chart-toggle .items .item').hide();
                $('.chart-toggle .items .item:eq(3)').show();
                $('.chart-toggle-copy .items .item').hide();
                $('.chart-toggle-copy .items .item:eq(3)').show();
            }
          });
        });
        $('.chart-toggle-nav button').each(function(i,e){
          $(this).on('click', function(){
            $('.chart-toggle-nav button').removeClass('active');
            $(this).addClass('active');
            $('.chart-toggle .items .item').hide();
            $('.chart-toggle .items .item:eq('+i+')').show();
            $('.chart-toggle-copy .items .item').hide();
            $('.chart-toggle-copy .items .item:eq('+i+')').show();
          });
        });

    }

};

export default ChartToggle;